import React from 'react'
import {Icon} from '@chakra-ui/react'

const DeleteIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="delete" {...props}>
            <path
                id="Vector"
                d="M29.3595 38.9906H11.4744C9.254 38.9906 7.44761 37.2501 7.35353 35.0391L6.20572 6.56971C6.19631 6.31568 6.2904 6.06166 6.46915 5.8829C6.64791 5.69474 6.89253 5.59125 7.14655 5.59125H33.8566C34.1106 5.59125 34.3647 5.69474 34.534 5.8829C34.7034 6.07107 34.8069 6.31568 34.7975 6.57912L33.4709 35.0674C33.3674 37.2689 31.561 39 29.3501 39L29.3595 38.9906ZM8.12501 7.46349L9.23518 34.9545C9.28223 36.1587 10.2701 37.0995 11.4744 37.0995H29.3595C30.5543 37.0995 31.5422 36.1587 31.5986 34.9639L32.8782 7.46349H8.12501Z"
                fill="currentColor"
            />
            <path
                id="Vector_2"
                d="M37.9302 7.46347H2.94083C2.42337 7.46347 2 7.0401 2 6.52264C2 6.00519 2.42337 5.58182 2.94083 5.58182H37.9302C38.4476 5.58182 38.871 6.00519 38.871 6.52264C38.871 7.0401 38.4476 7.46347 37.9302 7.46347Z"
                fill="currentColor"
            />
            <path
                id="Vector_3"
                d="M26.1604 7.39762C25.643 7.39762 25.2196 6.97425 25.2196 6.4568V4.0671C25.2196 3.40852 24.7115 2.88165 24.0812 2.88165H16.8462C16.2159 2.88165 15.7078 3.41793 15.7078 4.0671V6.4568C15.7078 6.97425 15.2845 7.39762 14.767 7.39762C14.2495 7.39762 13.8262 6.97425 13.8262 6.4568V4.0671C13.8262 2.37361 15.181 1 16.8462 1H24.0812C25.7464 1 27.1012 2.37361 27.1012 4.0671V6.4568C27.1012 6.97425 26.6779 7.39762 26.1604 7.39762Z"
                fill="currentColor"
            />
            <path
                id="Vector_4"
                d="M13.8263 34.644C13.3277 34.644 12.9137 34.2488 12.8855 33.7408L11.86 9.95668C11.8412 9.43922 12.2364 8.99703 12.7632 8.97821C13.2901 8.9594 13.7229 9.35455 13.7417 9.88141L14.7672 33.6655C14.786 34.183 14.3908 34.6252 13.864 34.644C13.8546 34.644 13.8358 34.644 13.8263 34.644Z"
                fill="currentColor"
            />
            <path
                id="Vector_5"
                d="M27.0918 34.644C27.0918 34.644 27.0636 34.644 27.0542 34.644C26.5368 34.6251 26.1322 34.1829 26.151 33.6655L27.1765 9.88139C27.1953 9.36393 27.6658 8.96878 28.155 8.97819C28.6724 8.99701 29.077 9.4392 29.0582 9.95665L28.0327 33.7408C28.0139 34.2488 27.5905 34.644 27.0918 34.644Z"
                fill="currentColor"
            />
            <path
                id="Vector_6"
                d="M20.4399 34.644C19.9224 34.644 19.499 34.2206 19.499 33.7031V9.93785C19.499 9.4204 19.9224 8.99702 20.4399 8.99702C20.9573 8.99702 21.3807 9.4204 21.3807 9.93785V33.7125C21.3807 34.23 20.9573 34.6534 20.4399 34.6534V34.644Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DeleteIcon
